export const POSTER1 = 'https://ydschool-video.nosdn.127.net/1622107517404%E9%BB%98%E8%AE%A4%E5%B0%81%E9%9D%A21.jpg'
export const POSTER2 = 'https://ydschool-video.nosdn.127.net/1622107556852%E9%BB%98%E8%AE%A4%E5%B0%81%E9%9D%A22.jpg'
export const POSTER3 = 'https://ydschool-video.nosdn.127.net/1622107570361%E9%BB%98%E8%AE%A4%E5%B0%81%E9%9D%A23.jpg'
export const POSTER4 = 'https://ydschool-video.nosdn.127.net/1622107582706%E9%BB%98%E8%AE%A4%E5%B0%81%E9%9D%A24.jpg'
